import { Modal, Button } from 'reactstrap';

type ModalDangerProps = {
  isModal: boolean;
  modalTitle: string;
  modalMessage: string;
  onClose: (value: boolean) => void;
};

const ModalDanger = ({ isModal, modalTitle, modalMessage, onClose }: ModalDangerProps) => {
  return (
    <>
      <Modal className="modal-dialog-centered" isOpen={isModal} toggle={() => onClose(false)}>
        <div className="modal-header bg-danger">
          <h3 className="modal-title text-white" id="modal-title-notification">
            Allergy / Medical Notes
          </h3>
          <button
            aria-label="Close"
            className="close"
            data-dismiss="modal"
            type="button"
            onClick={() => onClose(false)}
          >
            <span aria-hidden={true}>×</span>
          </button>
        </div>
        <div className="modal-body">
          <div className="py-3 text-center">
            <i className="fas fa-briefcase-medical fa-3x text-danger" />
            <h4 className="heading mt-2" style={{ textTransform: 'none' }}>
              {modalTitle}
            </h4>
            <div className="text-center" style={{ fontSize: '2rem' }}>
              <strong>{modalMessage}</strong>
            </div>
          </div>
        </div>
        <div className="modal-footer">
          <Button
            className="text-white ml-auto"
            color="primary"
            data-dismiss="modal"
            type="button"
            onClick={() => onClose(false)}
          >
            Close
          </Button>
        </div>
      </Modal>
    </>
  );
};

export default ModalDanger;
